import { Button } from "@/components/ui/button";
import { NavLink } from "@/components/NavLink";
import { ArrowRight } from "lucide-react";

interface BlogDoneForYouCTAProps {
  variant?: "lawn-care" | "landscaping" | "general";
}

export const BlogDoneForYouCTA = ({ variant = "general" }: BlogDoneForYouCTAProps) => {
  const getContent = () => {
    switch (variant) {
      case "lawn-care":
        return {
          heading: "Want a professional lawn care website done for you?",
          description: "Skip the DIY headache. Get a conversion-optimized website built by specialists who know lawn care.",
          link: "/lawn-care-website-design/",
          cta: "See Lawn Care Website Design"
        };
      case "landscaping":
        return {
          heading: "Want a professional landscaping website done for you?",
          description: "Skip the DIY headache. Get a high-converting website built by specialists who know landscaping.",
          link: "/landscaping-website-design/",
          cta: "See Landscaping Website Design"
        };
      default:
        return {
          heading: "Want this done for you?",
          description: "Skip the DIY headache. Get a conversion-optimized website built by specialists who know your industry.",
          link: "/websites/",
          cta: "See Website Pricing"
        };
    }
  };

  const content = getContent();

  return (
    <div className="my-8 p-6 rounded-xl bg-primary/5 border-2 border-primary/20">
      <h3 className="text-xl font-bold mb-2">{content.heading}</h3>
      <p className="text-muted-foreground mb-4">{content.description}</p>
      <NavLink to={content.link}>
        <Button className="gap-2">
          {content.cta}
          <ArrowRight className="h-4 w-4" />
        </Button>
      </NavLink>
    </div>
  );
};
